/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S11_Li2_DescInputs */

const tr_iade_iptal_s11_li2_desc = /** @type {(inputs: Iade_Iptal_S11_Li2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diğer veri taleplerinizi kvkk@emonse.com adresine iletebilirsiniz. Önceden kabul edilmiş sözleşme hükümlerine göre doğmuş veri erişimi ve dışa aktarma hakları saklıdır.`)
};

const en_iade_iptal_s11_li2_desc = /** @type {(inputs: Iade_Iptal_S11_Li2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can send other data requests to kvkk@emonse.com. Data access and export rights arising under a previously accepted contract remain valid.`)
};

const de_iade_iptal_s11_li2_desc = /** @type {(inputs: Iade_Iptal_S11_Li2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weitere Datenanfragen können Sie an kvkk@emonse.com senden. Ansprüche auf Datenzugriff und Export aus bereits angenommenen Vertragsfassungen bleiben bestehen.`)
};

const ru_iade_iptal_s11_li2_desc = /** @type {(inputs: Iade_Iptal_S11_Li2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Другие запросы о данных можно направить на kvkk@emonse.com. Права на доступ к данным и экспорт по ранее принятому договору сохраняются.`)
};

/**
* | output |
* | --- |
* | "You can send other data requests to kvkk@emonse.com. Data access and export rights arising under a previously accepted contract remain valid." |
*
* @param {Iade_Iptal_S11_Li2_DescInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s11_li2_desc = /** @type {((inputs?: Iade_Iptal_S11_Li2_DescInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S11_Li2_DescInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s11_li2_desc(inputs)
	if (locale === "de") return de_iade_iptal_s11_li2_desc(inputs)
	if (locale === "ru") return ru_iade_iptal_s11_li2_desc(inputs)
	return tr_iade_iptal_s11_li2_desc(inputs)
});